module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v("上传头像")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-column"
  }, [_c('avatar-crop', {
    attrs: {
      "default-image": _vm.currentAvatar,
      "show-circle": "",
      "return-base64": ""
    },
    on: {
      "change": _vm.onAvatarChange
    }
  }), _vm._v(" "), (_vm.btnVisible) ? [(_vm.percent > 0 && _vm.percent < 100) ? _c('u-progress', {
    attrs: {
      "percent": _vm.percent
    }
  }) : _vm._e(), _vm._v(" "), _c('u-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("上传")])] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2648f1e4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Avatar.vue
// module id = 249
// module chunks = 6